import * as React from "react";

import classNames from "classnames";

import DocInlineText from "./InlineText";

interface DocMatcherProps extends MatcherNode, EveryNodeArgs {}

interface DocMatcherState {

}

export default class DocMatcher extends React.Component<DocMatcherProps, DocMatcherState> {
  state = {
    activeMatchItemUID: null,
    activeMatchItemLetter: null,
  };

  onMatchItemClick = (futureUID: string, futureLetter: string, e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();

    if (this.props.inactiveBoolean) {return null;}

    const pastUID = this.state.activeMatchItemUID;
    const pastLetter = this.state.activeMatchItemLetter;

    if (pastUID) {
      if (pastUID === futureUID) {
        this.setState({activeMatchItemUID: null, activeMatchItemLetter: null});
      } else if (pastLetter === futureLetter) {
        this.setState({activeMatchItemUID: futureUID, activeMatchItemLetter: futureLetter});
      } else {
        this.setState({activeMatchItemUID: null, activeMatchItemLetter: null});

        let aUID, bUID;
        if (futureLetter === "a") {
          aUID = futureUID;
          bUID = pastUID;
        } else {
          aUID = pastUID;
          bUID = futureUID;
        }

        const filteredValues = (this.props.value || []).filter((value) => value[0] !== aUID && value[1] !== bUID);

        const futureValues = filteredValues.concat([[aUID, bUID]]);

        this.props.currentUser.addState({[this.props.uid]: {"value": futureValues}});
      }
    } else {
      this.setState({activeMatchItemUID: futureUID, activeMatchItemLetter: futureLetter});
    }
  };

  renderMatcherRow(pair: readonly [MatcherItemNode, MatcherItemNode], isMatched: boolean) {
    const [a, b] = pair;

    const aClasses = classNames("doc-matcher-item doc-matcher-item-a", {"selected": a.uid === this.state.activeMatchItemUID});
    const bClasses = classNames("doc-matcher-item doc-matcher-item-b", {"selected": b.uid === this.state.activeMatchItemUID});

    return (
      <div className={classNames("doc-matcher-row", {"doc-matcher-matched-row": isMatched})} key={a.uid + b.uid}>
        <div className={aClasses} onClick={this.onMatchItemClick.bind(this, a.uid, "a")}>
          <p>
            <DocInlineText content={a.content} uid={a.uid} contentKey="content" editState={this.props.editState}/>
          </p>
        </div>
        <div className={bClasses} onClick={this.onMatchItemClick.bind(this, b.uid, "b")}>
          <p>
            <DocInlineText content={b.content} uid={b.uid} contentKey="content" editState={this.props.editState}/>
          </p>
        </div>
      </div>
    );
  }

  render() {
    const classes = classNames("doc-matcher", {"inactive": this.props.inactiveBoolean});

    let restAs = this.props.contentA;
    let restBs = this.props.contentB;
    const valueIdPairs = this.props.value || [];

    const matchedPairs = valueIdPairs.map((valueIdPair) => {
      const valueA = restAs.find((a) => a.uid === valueIdPair[0]);
      const valueB = restBs.find((b) => b.uid === valueIdPair[1]);

      if ((valueA !== undefined) && (valueB !== undefined)) {
        restAs = restAs.filter((a) => a.uid !== valueIdPair[0]);
        restBs = restBs.filter((b) => b.uid !== valueIdPair[1]);
        return([valueA, valueB] as const);
      } else {
        return(null);
      }
    }).filter((matchPair) => matchPair !== null);

    const unmatchedPairs = restAs.map((restA, i) => [restAs[i], restBs[i]] as const);

    const matchedRows = matchedPairs.map((matchedPair) => this.renderMatcherRow(matchedPair, true));
    const unmatchedRows = unmatchedPairs.map((unmatchedPair) => this.renderMatcherRow(unmatchedPair, false));

    return (
      <div className={classes}>
        {matchedRows}
        {unmatchedRows}
      </div>
    );
  }
}
